import React from 'react';
import { NavLink } from 'react-router-dom';
import useAuth from '../../hooks/useAuth';
import logo from '../../image/1.png';
import './Header.css';


const Header = () => {
    const { user, logOut } = useAuth();
    return (
        <nav class="navbar navbar-expand-lg navbar-light color-nav">
            <div class="container">
                <img className="logo" src={logo} alt="" />
                <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                    <span class="navbar-toggler-icon"></span>
                </button>
                <ul class="navbar-nav me-auto mb-2 mb-lg-0">
                    <li className="nav-item">
                        <NavLink className="nav-link text-white" to="/home">Home</NavLink>
                        <NavLink className="nav-link text-white" to="/shop">Shop</NavLink>
                        <NavLink className="nav-link text-white" to="/review">Review</NavLink>
                        <NavLink className="nav-link text-white" to="/inventory">Inventory</NavLink>
                        {user.email && <span style={{ color: 'white' }}>Hello {user.displayName} </span>}
                        {
                            user.email ?
                                <button onClick={logOut}>log out</button>
                                :
                                <NavLink className="nav-link text-white" to="/login">Login</NavLink>}
                    </li>
                </ul>
            </div>
            <NavLink className="card-btn d-flex align-items-center text-center align-middle button-top" to="/login">Sign In</NavLink>
            /</nav>
    );
};

export default Header;